import React, { useState, useEffect } from 'react';
import styles from './Users.module.css';

import LayoutDefault from '../../Components/LayoutDefault/LayoutDefault';
import Panel from '../../Components/Panel/Panel';
import PanelListDefault from '../../Components/PanelListDefault/PanelListDefault';
import RemoveIdsNotFound from '../../Components/RemoveIdsNotFound/RemoveIdsNotFound';
import ExecuteAxios from '../../Components/ExecuteAxios/ExecuteAxios';
import ResetVariables from '../../Components/ResetVariables/ResetVariables';
import ApplyAttributes from '../../Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from '../../Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import { useContext } from 'react';
import { AuthContext } from '../../Contexts/auth';
import LoadingIndicator from '../../Components/LoadingIndicator/LoadingIndicator';
import { FaList, FaEdit } from 'react-icons/fa';

function Users() {
    const { clientSelected, clientSelectedHandled, setClientSelectedHandled } = useContext(AuthContext);
    const [id, setId] = useState(null)
    const [name, setName] = useState(null);
    const [username, setUsername] = useState(null);
    const [email, setEmail] = useState(null);
    const [phone, setPhone] = useState(null);
    const [password, setPassword] = useState(null);
    const [isActive, setIsActive] = useState('S')

    const [usersRecords, setUsersRecords] = useState(null)
    const [usersRecordDetail, setUsersRecordDetail] = useState(null)
    const [selectedsUsers, setSelectsUsers] = useState([])
    const [inserting, setInserting] = useState(false)
    const [updating, setUpdating] = useState(false)
    const [loadingPanel, setLoadingPanel] = useState(false)
    const [activeTab, setActiveTab] = useState('list');
    const isMobile = window.innerWidth <= 786;

    const attributeList = [
        { name: "id", value: id, setter: setId },
        { name: "name", value: name, setter: setName },
        { name: "username", value: username, setter: setUsername },
        { name: "email", value: email, setter: setEmail, width: '300px' },
        { name: "phone", value: phone, setter: setPhone },
        { name: "password", value: password, setter: setPassword },
        {
            name: "isActive", value: isActive, setter: setIsActive, defaultValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
    ];

    useEffect(() => {
        const fetchData = (async () => {
            await getUsersDetail(0)
            await getUsersGrid()
        })

        fetchData()
    }, []);

    useEffect(() => {
        if (!clientSelected || !clientSelectedHandled) return
        setClientSelectedHandled(false)

        const fetchData = (async () => {
            setInserting(false)
            setUpdating(false)
            await setDetailRecord(selectedsUsers)
            await getUsersGrid()
        })

        fetchData()
    }, [clientSelectedHandled]);

    useEffect(() => {
        setDetailRecord(selectedsUsers)
    }, [selectedsUsers]);

    async function setDetailRecord(selectedsUsers) {
        if (selectedsUsers && selectedsUsers.length === 1) {
            setInserting(false)
            setUpdating(false)
            await getUsersDetail(selectedsUsers[0])
        } else {
            setUpdating(false)
            ResetVariables.resetVariables(attributeList)
        }
    }

    async function getUsersGrid() {
        const parameters = {
            clientId: clientSelected ?? 0,
            isActive: 'S'
        }
        const usersRecordsResponse = await ExecuteAxios.api('get', `/user/get-user-active-grid/`, { params: parameters });
        setUsersRecords(usersRecordsResponse);
        RemoveIdsNotFound.remove(usersRecordsResponse, setSelectsUsers, selectedsUsers)
    }

    async function getUsersDetail(selectedUser) {
        const parameters = {
            id: selectedUser
        }
        const usersRecordsDetail = await ExecuteAxios.api('get', `/user/get-user-by-id-detail/`, { params: parameters });
        setUsersRecordDetail(usersRecordsDetail);
        if (usersRecordsDetail) {
            ApplyAttributes.applyAttributes(usersRecordsDetail, attributeList, inserting)
        }
    }

    async function putUsers() {
        try {
            setLoadingPanel(true)
            const parameters = {
                id: selectedsUsers[0],
                name: name,
                username: username,
                email: email,
                phone: phone,
                password: password,
                clientId: clientSelected ?? 0,
                isActive: isActive
            }
            return await ExecuteAxios.api('put', `/user/`, parameters);
        } finally {
            setLoadingPanel(false)
        }
    }

    async function postUsers() {
        try {
            const parameters = {
                name: name,
                username: username,
                email: email,
                phone: phone,
                password: password,
                clientId: clientSelected ?? 0,
                isActive: isActive
            }
            return await ExecuteAxios.api('post', `/user/`, parameters);
        } finally {
            setLoadingPanel(false)
        }
    }

    const mainPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
    };

    return (
        <LayoutDefault>
            {(activeTab === 'list' || !isMobile) && (
                <Panel
                    className={'main-modal two left'}
                    style={mainPanelStyle}
                    titlePage={'Administradores'}
                    canViewCRUD={true}
                    recordsSelected={[]}
                    viewOnlyOneRecordCRUD={false}
                    resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                    dataListedAttributes={usersRecords}
                    attributeList={attributeList}
                    onUpdateIdSelected={setSelectsUsers}
                >
                    <LoadingIndicator loaded={usersRecords && !loadingPanel}>
                        <PanelListDefault
                            onUpdateIdSelected={setSelectsUsers}
                            idsSelected={selectedsUsers}
                            data={usersRecords}
                            attributeList={attributeList}
                            selectFirstRecord={true}
                            inserting={inserting}
                            updating={updating}
                        />
                    </LoadingIndicator>
                </Panel>
            )}

            {(activeTab === 'detail' || !isMobile) && (
                <Panel
                    className={'main-modal two right'}
                    style={mainPanelStyle}
                    titlePage={'Administrador selecionado'}
                    setUpdating={setUpdating}
                    setInserting={setInserting}
                    inserting={inserting}
                    updating={updating}
                    enableEdit={true}
                    canEdit={selectedsUsers && selectedsUsers.length === 1}
                    putFunction={putUsers}
                    enableNewRecord={true}
                    canNewRecord={true}
                    postFunction={postUsers}
                    canViewCRUD={true}
                    recordsSelected={[]}
                    viewOnlyOneRecordCRUD={false}
                    resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                    dataListedAttributes={usersRecords}
                    attributeList={attributeList}
                    onUpdateIdSelected={setSelectsUsers}
                    reloadFilter={
                        async () => {
                            await getUsersGrid()
                        }
                    }
                    cancelFunction={
                        async () => {
                            await setDetailRecord(selectedsUsers)
                        }
                    }
                >
                    <LoadingIndicator loaded={usersRecordDetail && !loadingPanel}>
                        <AutomaticallyListedAttributes
                            list={usersRecordDetail}
                            attributeList={attributeList}
                            readOnlyAttributes={!inserting && !updating}
                        />
                    </LoadingIndicator>
                </Panel>
            )}

            {/* Navegação inferior mobile */}
            {isMobile && (
                <div className={styles.bottomNav}>
                    <button
                        className={`${styles.navButton} ${activeTab === 'list' ? styles.active : ''}`}
                        onClick={() => setActiveTab('list')}
                    >
                        <FaList />
                        <span>Lista</span>
                    </button>
                    <button
                        className={`${styles.navButton} ${activeTab === 'detail' ? styles.active : ''}`}
                        onClick={() => setActiveTab('detail')}
                    >
                        <FaEdit />
                        <span>Detalhe</span>
                    </button>
                </div>
            )}
        </LayoutDefault>
    );
}

export default Users;